import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Check, Copy } from "lucide-react";
import { toast } from "sonner";

export function CodeBlock({ label, code, language = "", testid, maxHeight = "420px" }) {
  const [copied, setCopied] = useState(false);
  const doCopy = async () => {
    try {
      await navigator.clipboard.writeText(code || "");
      setCopied(true);
      toast.success("Copied to clipboard");
      setTimeout(() => setCopied(false), 1200);
    } catch {
      toast.error("Could not copy");
    }
  };
  return (
    <div className="code-surface overflow-hidden">
      <div className="flex items-center justify-between px-3 py-2 border-b border-[hsl(var(--code-border))]">
        <div className="text-xs text-muted-foreground font-mono">
          {label} {language && <span className="opacity-60">· {language}</span>}
        </div>
        <Button
          data-testid={testid}
          variant="ghost"
          size="sm"
          className="h-7 px-2 gap-1.5"
          onClick={doCopy}
        >
          {copied ? <Check className="h-3.5 w-3.5" /> : <Copy className="h-3.5 w-3.5" />}
          <span className="text-xs">{copied ? "Copied" : "Copy"}</span>
        </Button>
      </div>
      <pre
        className="scroll-thin overflow-auto p-4 text-[12.5px] leading-6 font-mono whitespace-pre"
        style={{ maxHeight }}
      >
        {code || "(empty)"}
      </pre>
    </div>
  );
}
